import { render, staticRenderFns } from "./dev-bind-auth.vue?vue&type=template&id=d48faf4a&scoped=true&"
import script from "./dev-bind-auth.vue?vue&type=script&lang=js&"
export * from "./dev-bind-auth.vue?vue&type=script&lang=js&"
import style0 from "./dev-bind-auth.vue?vue&type=style&index=0&id=d48faf4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48faf4a",
  null
  
)

export default component.exports